<template>
  <ValidationObserver ref="step4Form" >
    <v-dialog v-model="dialog">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary darken-1"
          block
          v-bind="attrs"
          v-on="on"
        >
          {{ $t('actions.open_terms_of_service') }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text v-html="htmlTosFile">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="dialog = false">{{ $t('actions.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-form>
      <ValidationProvider v-for="(checkbox, index) in checkboxes"
        :key="index"
        :name="checkbox.label"
        :rules="checkbox.required === true ? 'required|is:true' : ''"
        v-slot="{}">
        <v-checkbox
          v-model="formValues[checkbox.name]"
          :label="checkbox.required === true ? checkbox.label + '*' : checkbox.label"
          value="true"
          color="primary darken-1"
        >
        </v-checkbox>
      </ValidationProvider>
      <div class="signature-pad-container">
        <div class="signature-pad-label">
          {{$t('fields.signature')}}
        </div>
        <VueSignaturePad
          :style="cssVars"
          height="200px"
          :class="{ 'signature-placeholder': isSignatureEmtpy }"
          ref="signaturePad"
          :customStyle="{
            'border': '1px solid #979797',
            'border-radius': '4px',
            'padding': 0,
            'margin': 0
          }"
          saveType="image/svg+xml"
          :options="{ onBegin }"
        />
        <v-btn @click="clearSignature" :disabled="isSignatureEmtpy === true" outlined small class="mt-2">
          {{ $t('actions.clear_signature')}}
        </v-btn>
      </div>
    </v-form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState } from 'vuex'
import marked from 'marked'
var renderer = new marked.Renderer()
renderer.link = function (href, title, text) {
  var link = marked.Renderer.prototype.link.call(this, href, title, text)
  return link.replace('<a', '<a target=\'_blank\' ')
}
marked.setOptions({
  renderer,
})

export default {
  data () {
    return {
      formValues: {},
      isSignatureEmtpy: true,
      validForm: false,
      dialog: false,
      htmlTosFile: null,
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    cssVars () {
      return {
        '--sign-here-text': `'${ this.$t('fields.sign_here') }'`,
      }
    },
    checkboxes () {
      let languageCode = this.$i18n.locale
      if (!this.tosConfiguration) {
        return []
      }
      return this.tosConfiguration.checkboxes.map(function (checkbox) {
        let text = checkbox.text.filter(text => text.languageCode === languageCode)[0]
        return {
          label: text.value,
          name: checkbox.fieldName,
          required: checkbox.required,
        }
      })
    },
    isCompleted () {
      if (!this.isSignatureEmtpy && this.validForm) {
        return true
      } else {
        return false
      }
    },
    // tosContent () {
    //   if (this.service.tosFile) {
    //     const html = marked(this.service.tosFile || '')
    //     return html
    //   } else {
    //     return ''
    //   }
    // },
    tosConfiguration () {
      if (!this.service.configuration) {
        return null
      }
      return this.service.configuration.registrationCardConfiguration.steps.filter(step => step.type === 'TOS_SIGNATURE')[0].configuration
    },
    ...mapState(['service', 'registrationCards']),
  },
  methods: {
    onBegin () {
      this.isSignatureEmtpy = false
    },
    clearSignature () {
      this.isSignatureEmtpy = true
      this.$refs.signaturePad.clearSignature()
    },
  },
  watch: {
    'service.tosFile' () {
      this.htmlTosFile = marked(this.service.tosFile || '')
    },
    isCompleted: function (newValue, oldValue) {
      this.$emit('onIsCompletedChange', newValue)
    },
    tosConfiguration: {
      immediate: true,
      handler: function (value) {
        if (value) {
          const locale = this.$i18n.locale
          let languageFile = value.tosFileId.find((file) => { return file.languageCode === locale })
          if (languageFile === undefined && locale !== 'en') {
            languageFile = value.tosFileId.find((file) => { return file.languageCode === locale })
          }
          if (languageFile === undefined) {
            languageFile = value.tosFileId[0]
          }
          if (languageFile !== undefined) {
            this.$store.dispatch('service/getTosFile', { fileId: languageFile.value })
          }
        }
      },
    },
  },
  mounted () {
    this.$watch(
      () => {
        return this.$refs.step4Form.flags.valid
      },
      (val) => {
        this.validForm = val
      },
      {
        immediate: true,
      }
    )
  },
}
</script>

<style lang="scss">
.signature-pad-container {
  position: relative;
  margin-top: 8px;

  .signature-pad-label {
    position: absolute;
    left: 12px;
    padding: 0 2px;
    top: -8px;
    display: inline-block;
    color: rgba(0,0,0,.6);
    background-color: #FFFFFF;
    font-size: 12px;
    line-height: 16px;
  }
}
.signature-placeholder:before {
  content: var(--sign-here-text);
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 20px;
  transform: translate(-50%, -100%);
  color: rgb(158, 158, 158);
}
</style>
